import React, { useEffect, useState } from 'react';
import FireFetch from "../../Firebase/FireFetch";
import { message, Form, Input, Select, Radio, Skeleton } from "antd";
import { Button } from "evergreen-ui";
import { MDBCol } from "mdbreact";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import { useAuthState } from 'react-firebase-hooks/auth';
import { getDatabase, ref, update } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, listAll, ref as storageRef, uploadBytes } from "firebase/storage";
import { useAuth } from "../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";

const { TextArea } = Input;
var db = getDatabase(Firebase);
var storage = getStorage(Firebase);
var auth = getAuth(Firebase);
const EditStory = (props) => {
	const { canAccessModule } = useAuth();
	const canUpdateStory = canAccessModule("SUCCESS_STORIES", "update");
	const [form] = Form.useForm();
	const [user] = useAuthState(auth);
	const [showLoading, setShowLoading] = useState(false);
	const [users, usersLoading] = useListVals(ref(db, "talmidsdb/users"));
	const [radioValue, setRadioValue] = useState();
	const [communityArray, communitiesLoading] = useListVals(ref(db, "talmidsdb/communities"));
	const [orgArray, orgsLoading] = useListVals(ref(db, "talmidsdb/organisations"));
	const [languageArray, languagesLoading] = useListVals(ref(db, "talmidsdb/languages"));
	const [consents, consentsLoading] = useListVals(ref(db, "talmidsdb/consents"));
	const [isIndividual, setIsIndividual] = useState(false);
	const [filesList, setFilesList] = useState([]);
	const [urlArray, setUrlArray] = useState([]);
	const [groupArray, groupsLoading] = useListVals(ref(db, "talmidsdb/groups"));
	const [mediaLoading, setMediaLoading] = useState(false);

	useEffect(() => {
		setUrlArray([]);
		setMediaLoading(true);
		const paths = [
			"talmidsdb/successStories/" + props.story?.storyID + "/",
			"talmidsdb/SuccessStories/" + props.story?.storyID + "/",
			"System/SuccessStories/" + props.story?.storyID + "/",
		];
		Promise.all(paths.map((path) => listAll(storageRef(storage, path)).catch(() => ({ items: [] }))))
			.then((results) => {
				const refs = results.flatMap((res) => res.items || []);
				Promise.all(refs.map((itemRef) => getDownloadURL(itemRef)))
					.then((urls) => {
						setUrlArray(Array.from(new Set(urls)));
						setMediaLoading(false);
					})
					.catch(() => {
						setUrlArray([]);
						setMediaLoading(false);
					});
			});
		form.resetFields()
	}, [props.story?.storyID, form])

	const onRadioChange = (e) => {
		setRadioValue(e.target.value);
		if (e.target.value === "individual" || e.target.value === "family") {
			setIsIndividual(true);
		} else {
			setIsIndividual(false);
		}
	};
	const addFile = (fileObject) => {
		uploadBytes(storageRef(storage, "talmidsdb/successStories/" + props.story?.storyID + "/" + fileObject.fileID), fileObject.file)
			.then(function (snapshot) {
				message.success("Images uploaded successfully");
			});
	}

	const functionWithPromise = object => { //a function that returns a promise
		addFile(object);
	}

	const anAsyncFunction = async item => {
		return functionWithPromise(item)
	}

	const addImageArray = async (list) => {
		return await Promise.all(list.map(item => anAsyncFunction(item)))
	}

	const handleFileUpload = (e) => {
		const fileObject = {
			"fileID": e.target.id,
			"file": e.target.files[0]
		}
		if (!filesList.includes(fileObject)) {
			var index = filesList.findIndex(x => x.fileID === fileObject.fileID);
			console.log(index);
			if (index !== -1) {
				filesList.splice(index, 1);
				setFilesList(filesList => [...filesList, fileObject]);
			} else {
				setFilesList(filesList => [...filesList, fileObject]);
			}
		}
	}

	const editStory = (values) => {
		if (!canUpdateStory) {
			message.error("You do not have permission to update stories.");
			return;
		}

		setShowLoading(true);
		let storyObject = {
			...props.story,
			...values
		};

		delete storyObject["photo1"];
		delete storyObject["photo2"];
		delete storyObject["photo3"];

		Object.entries(storyObject).forEach(([key, value]) => {
			if (value === undefined) {
				storyObject[key] = props.story[key];
			}
		});
		addImageArray(filesList)
			.then((r) => {
				update(ref(db, "talmidsdb/successStories/" + props.story?.storyID), storyObject)
					.then((result) => {
						FireFetch.addLog("successStories", props.story?.storyID, "Create");
						message.success("Story edited successfully");
						setShowLoading(false);
						form.resetFields();
						props.modal(false);

					})
					.catch((error) => {
						message.error(`Unable to edit story. An error occurred : ${error.message}`);
						setShowLoading(false);
					})
			})
	}

	const onFailed = () => {
		message.error("Form Has errors!");
	}

	const isLookupLoading = usersLoading || communitiesLoading || orgsLoading ||
		languagesLoading || consentsLoading || groupsLoading || mediaLoading;

	if (isLookupLoading) {
		return <Skeleton active paragraph={{ rows: 14 }} />;
	}

	return (
		<>
			<MDBCol md={12}>
				<Form
					form={form}
					layout="vertical"
					onFinish={editStory}
					onFinishFailed={onFailed}
					initialValues={{
						submittedBy: props.story?.submittedBy,
						language: props.story?.language,
						community: props.story?.community,
						group: props.story?.groupID,
						organisation: props.story?.organisation,
						storyTitle: props.story?.storyTitle,
						storyTopic: props.story?.storyTopic,
						storySourceType: props.story?.storySourceType,
						participantsName: props.story?.participantsName,
						gender: props.story?.gender,
						maritalStatus: props.story?.maritalStatus,
						maleChildren: props.story?.maleChildren,
						femaleChildren: props.story?.femaleChildren,
						situationBefore: props.story?.situationBefore,
						whatHappened: props.story?.whatHappened,
						situationAfter: props.story?.situationAfter,
						lifeChange: props.story?.lifeChange,
						quote: props.story?.quote,
						storyAuthor: props.story?.storyAuthor,
						prayerRequest: props.story?.prayerRequest,
						consent: props.story?.consent,
						actOfLove: props.story?.actOfLove,
						securityRisk: props.story?.securityRisk,
						submittedPreviously: props.story?.submittedPreviously,

					}}
				>
					<Form.Item label="Language"
						name="languageID"
						rules={[{ required: false, message: 'Please input language!' }]}
					>
						<Select placeholder="Select language"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{languageArray.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.languageName}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Community"
						name="communityID"
						rules={[{ required: false, message: 'Please input community!' }]}>
						<Select placeholder="Select community"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{communityArray.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Organisation"
						name="organisationID"
						rules={[{
							message: 'Please select organisation!'
						}]}
					>
						<Select placeholder="Select organisation"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{orgArray.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="Group"
						name="groupID"
						rules={[{

							message: 'Please select group!'
						}]}
					>
						<Select
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{groupArray.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.groupSelfName}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Submitted By"
						name="submittedBy"
						rules={[{

							message: 'Please select submitted by user!'
						}]}
					>
						<Select placeholder="Select submitted by User"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{users.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Story Title"
						name="storyTitle">
						<Input placeholder="Enter the story title" id="title" />
					</Form.Item>
					<Form.Item label="Participants Name / Group Name"
						name="participantsName"
						rules={[{ message: 'Please input group type!' }]}
					>
						<Input placeholder="Enter the name of the participants" id="title" />
					</Form.Item>
					<Form.Item
						label="Story's source type"
						name="storySourceType">
						<Radio.Group onChange={onRadioChange} value={radioValue}>
							<Radio value={"individual"}>Individual</Radio>
							<Radio value={"family"}>Families</Radio>
							<Radio value={"group"}>Groups</Radio>
						</Radio.Group>
					</Form.Item>
					<Form.Item label="Gender of participants"
						name="gender"
						rules={[{ message: 'Please select gender!' }]}>
						<Select placeholder="Select gender of participants"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Male", "Female", "Mixed"].map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>
					{
						isIndividual
							?
							<>
								<Form.Item label="Marital Status"
									name="maritalStatus">
									<Select placeholder="Select marital status"
										showSearch
										mode="multiple"
										optionFilterProp="children"
										filterOption={filterSelectOption}
										filterSort={sortSelectOptions}>
										{["Single", "Married", "Divorced", "Widowed"].map((item, index) => (
											<Select.Option key={index} value={item}>{item}</Select.Option>
										))}

									</Select>
								</Form.Item>
								<Form.Item label="Number of Living Male Children" name="maleChildren"
									rules={[
										{
											pattern: new RegExp(/\d+/),
											message: "Wrong number format!"
										}
									]}>
									<Input type="number" placeholder="enter number of living male children" />
								</Form.Item>
								<Form.Item label="Number of Living Female Children" name="femaleChildren"
									rules={[
										{
											pattern: new RegExp(/\d+/),
											message: "Wrong number format!"
										}
									]}>
									<Input type="number" placeholder="enter number of living female children" />
								</Form.Item>
							</>
							:
							null
					}

					<Form.Item label="Story's Key Topic"
						name="storyTopic">
						<Select placeholder="Select story topic"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Disaster Response", "Peace & Justice", "Economic Opportunity",
								"Community Health", "Food Security", "Other"].map((item, index) => (
									<Select.Option key={index} value={item}>{item}</Select.Option>
								))}

						</Select>
					</Form.Item>
					<Form.Item
						label="Life before Intervention By Organization"
						name="situationBefore"
						rules={[{ message: 'Please input life before intervention!' }]}
					>
						<TextArea type="text"
							placeholder="enter life before intervention"
							className="w-100 mr-4"
							id="notes" />

					</Form.Item>
					<Form.Item
						label="What did the Organization do"
						name="whatHappened"
						rules={[{ message: 'Please explain what happened!' }]}
					>
						<TextArea type="text"
							placeholder="explain how the change came about"
							className="w-100 mr-4"
							id="notes" />

					</Form.Item>
					<Form.Item
						label="Life after Intervention By Organization"
						name="situationAfter"
						rules={[{ message: 'Please life after intervention!' }]}
					>
						<TextArea type="text"
							placeholder="enter life after intervention"
							className="w-100 mr-4"
							id="notes" />

					</Form.Item>
					<Form.Item label="Life Change Summary"
						name="lifeChange"
						rules={[{ message: 'Please input group type!' }]}
					>
						<Input placeholder="Enter the summary of the change in life conditions" id="lifeChange" />
					</Form.Item>

					<Form.Item label="One Quote from Story"
						name="quote"
						rules={[{ message: 'Please input story quote!' }]}
					>
						<Input placeholder="Enter one quote from the story" id="quote" />
					</Form.Item>
					<Form.Item label="Story Author / Narrator"
						name="storyAuthor"
					>
						<Input placeholder="Enter the name of the story's author/narrator" id="narrator" />
					</Form.Item>

					<Form.Item label="What can people pray for in regard to this story?"
						name="prayerRequest"
					>
						<Input placeholder="Enter the prayer request" id="narrator" />
					</Form.Item>
					<Form.Item label="Consent"
						name="consent"
					>
						<Select placeholder="Select consent"
							showSearch>
							{consents.map((item, index) => (
								<Select.Option key={index} value={item.consentRequestID}>{item.fullName}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="Photo 1"
						name="photo1"
						rules={[{
							message: 'Please select a photo!'
						}]}
					>
						{urlArray[0] ? <a href={urlArray[0]}>Uploaded Photo 1</a> : "No photo uploaded"}
						<Input type="file"
							style={{ width: "100%" }}
							accept="image/*"
							onChange={handleFileUpload}
							placeholder="photo 1" id="photo-1" />
					</Form.Item>

					<Form.Item label="Photo 2" name="photo2">
						{urlArray[1] ? <a href={urlArray[1]}>Uploaded Photo 2</a> : "No photo uploaded"}
						<Input type="file"
							style={{ width: "100%" }}
							accept="image/*"
							onChange={handleFileUpload}
							placeholder="photo 2" id="photo-2" />
					</Form.Item>

					<Form.Item label="Photo 3" name="photo3">
						{urlArray[2] ? <a href={urlArray[2]}>Uploaded Photo 3</a> : "No photo uploaded"}
						<Input type="file"
							style={{ width: "100%" }}
							accept="image/*"
							onChange={handleFileUpload}
							placeholder="photo 3" id="photo-3" />
					</Form.Item>

					<Form.Item
						label="Does the story Represent an Act of Love?"
						name="actOfLove">
						<Radio.Group>
							<Radio value={"No"}>No</Radio>
							<Radio value={"Yes"}>Yes</Radio>
						</Radio.Group>
					</Form.Item>

					<Form.Item
						label="Is there a Security Risk with the story?"
						name="securityRisk">
						<Radio.Group>
							<Radio value={"No"}>No</Radio>
							<Radio value={"Yes"}>Yes</Radio>
						</Radio.Group>
					</Form.Item>

					<Form.Item
						label="Has the story been Submitted Previously to the funder?"
						name="submittedPreviously">
						<Radio.Group>
							<Radio value={"No"}>No</Radio>
							<Radio value={"Yes"}>Yes</Radio>
						</Radio.Group>
					</Form.Item>

					<Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canUpdateStory}>
						Edit
					</Button>

				</Form>
			</MDBCol>
		</>
	)
}

export default EditStory;
